var noTopBlock = document.querySelectorAll('.contain-no-header-block');
var withTopBlock = document.querySelectorAll('.contain-header-block');


const breadcrumbsContainerClass = 'breadcrumbs-container-hs';
const breadcrumbsContainerWithHeroClass = 'breadcrumbs-container-hs-with-hero';
const breadcrumbsContainerWithoutHeroClass = 'breadcrumbs-container-hs-no-hero';

var breadcrumbsList = document.querySelector('.breadcrumbs-hs');

//Remove landing pages without content in breadcrumbs
var bredcrumbsItems = document.querySelectorAll('.breadcrumbs-hs > .breadcrumbs__item');

if (bredcrumbsItems != null && bredcrumbsItems.length > 0) {
    bredcrumbsItems[1].style.display = 'none';
}

const breadcrumbsContainers = document.querySelectorAll(`.${breadcrumbsContainerClass}`);
//Check if withTopBlock exsist
if (withTopBlock.length > 0) {
    // Add breadcrumbsContainerWithHeroClass if withTopBlock exsist
    breadcrumbsContainers.forEach(container => {
        container.classList.add(breadcrumbsContainerWithHeroClass);
        container.classList.remove(breadcrumbsContainerClass);

    });
} else {
    // Else add breadcrumbsContainerWithoutHeroClass
    breadcrumbsContainers.forEach(container => {
        container.classList.add(breadcrumbsContainerWithoutHeroClass);
        container.classList.remove(breadcrumbsContainerClass);

    });

}